import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdicionaisEDescontosListarComponent } from './adicionais-e-descontos-listar.component';

const routes: Routes = [
  {path: '', component: AdicionaisEDescontosListarComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdicionaisEDescontosListarRoutingModule { }
